/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '../Box';
import Text from '../Text';
import styles from './CardProduct.module.css';
import useMediaQuery from '../../hooks/useMediaQuery';
import { formatVariant, getNumberWithDecimals } from '../../utils/cardForm';
import getInfinityBreakdown from '../../utils/infinityBreakdown';

const CardProducts = ({
  title,
  quantity,
  principalPrice,
  secondaryPrice,
  isPromo,
  isCitaFlow,
  appointmentDate,
  appointmentCenter,
  countryCurrency,
  variant,
  country,
  hasShipping,
  unitPrice,
}) => {
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const inter16 = isMobile ? 12 : 16;
  const inter14 = isMobile ? 12 : 14;

  const getVariantText = () => {
    switch (variant) {
      case 'infinity':
      case 'infinity_mkt':
      case 'infinity_lite_mkt':
      case 'infinity_full_mkt':
        return '';
      case 'infinity_refinement':
        return 'Refinamiento';
      case 'infinity_replacement':
        return 'Reposición';
      default:
        return formatVariant(variant);
    }
  };

  const unitPriceNumber = typeof unitPrice === 'number'
    ? unitPrice
    : getNumberWithDecimals(unitPrice);
  const breakdown = !hasShipping
    ? getInfinityBreakdown(unitPriceNumber, country, variant)
    : null;

  return (
    <Box jc="space-between" p="16px 0 0 0">
      <Box fd="row" jc="flex-start">
        <Box>
          <Box jc="space-between" fd="row">
            <Text s={inter16}>
              {title}
              {breakdown ? (
                <>
                  <br />
                  <Text c="#9E9E9E" s={inter14} lh={20}>Producción</Text>
                  <br />
                  <Text c="#9E9E9E" s={inter14} lh={20}>Marketing</Text>
                </>
              )
                : (
                  <>
                    {variant !== '' && <br />}
                    {variant !== '' && <Text c="#9E9E9E" s={inter14} lh={20}>{getVariantText()}</Text>}
                  </>
                )}
            </Text>
            <Text c="#9E9E9E" s={inter14} a="right">
              {breakdown ? (
                <>
                  <br />
                  {countryCurrency}
                  {breakdown.produccion}
                  <br />
                  {countryCurrency}
                  {breakdown.marketing}
                </>
              )
                : (
                  <>
                    {countryCurrency}
                    {principalPrice}
                  </>
                )}
            </Text>
          </Box>
          {isCitaFlow && (
            <Box jc="space-between" fd="row">
              <Text c="#616161" s={inter14}>
                {appointmentCenter}
              </Text>
              <Text
                className={
                  isPromo ? styles.textDecoration : styles.textDecorationError
                }
                c={isPromo ? '#F38FA6' : '#9E9E9E'}
                s={inter14}
              >
                {secondaryPrice && secondaryPrice}
              </Text>
            </Box>
          )}
          {isCitaFlow && (
            <Box jc="space-between" fd="row">
              <Text c="#616161" s={inter14}>
                {appointmentDate}
              </Text>
            </Box>
          )}
          <Box jc="space-between" fd="row">
            <Text c="#9E9E9E" s={inter14} lh={20}>
              {!isCitaFlow && 'Cant.'}
              {!isCitaFlow && <Text s={inter14}>{quantity}</Text>}
            </Text>
            {!isCitaFlow && (
              <Text
                className={
                  isPromo ? styles.textDecoration : styles.textDecorationError
                }
                c={isPromo ? '#F38FA6' : '#9E9E9E'}
                s={inter14}
              >
                {secondaryPrice && secondaryPrice}
              </Text>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

CardProducts.propTypes = {
  title: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  principalPrice: PropTypes.string.isRequired,
  secondaryPrice: PropTypes.string,
  isPromo: PropTypes.bool,
  isCitaFlow: PropTypes.bool,
  appointmentDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  appointmentCenter: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  countryCurrency: PropTypes.string,
  variant: PropTypes.string,
  country: PropTypes.string,
  hasShipping: PropTypes.bool,
  unitPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CardProducts.defaultProps = {
  secondaryPrice: '',
  isPromo: false,
  isCitaFlow: false,
  appointmentDate: '',
  appointmentCenter: '',
  countryCurrency: '$',
  variant: '',
  country: '',
  hasShipping: false,
  unitPrice: '',
};

export default CardProducts;
